import axios from "axios";
import { IP } from "../index";
// 查询所有用户数据
export async function selectallUser(data) {
  var resp = await axios.post(`${IP}/admin/vipUser/selectAll`, {
    ...data,
  });
  return resp.data;
}

//修改
export async function updateUser(data) {
  var resp = await axios.post(`${IP}/admin/vipUser/update`, {
    ...data,
  });
  return resp.data;
}

// 删除用户数据
export async function deleteUser(id) {
  var resp = await axios.post(`${IP}/admin/vipUser/deleteById`, {
    id,
  });
  return resp.data;
}
